import tabsStateSlice from './slice'

// eslint-disable-next-line import/prefer-default-export
export const tabsStateActions = tabsStateSlice.actions
